import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useDisplayChangelog = (): IGlobalStore['display_changelog'] => {
  return useSelector((store: IReducerStore) => store.global.display_changelog);
};
